import React, { useState, useEffect } from 'react'
import "./CustomDatatableProductCategory.css";
import { FaPencilAlt } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import { BiEdit } from "react-icons/bi"
import Pagination from '../Pagination/Pagination';
import { toast } from 'react-toastify';
import { deleteProductCategory, getProductCategories } from '../../services/http';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import DeleteConfirmation from '../DeleteConfirmation/DeleteConfirmation';
import { reload } from '../../utils/utils';
import AddOrEditProductCategory from '../AddOrEditProductCategory/AddOrEditProductCategory';




const CustomDatatableProductCategory = (props) => {

    const { columns, 
            data, 
            changePage, 
            pageCount, 
            pageNumber, 
            perPage, 
            handleShowDeleteModal, 
            handleCloseDeleteModal } = props;
    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);

    const [processOngoing, setProcessOngoing] = useState(false)

    // const itemsPerPage = 15;
    // const pagesVisited = pageNumber * itemsPerPage;

    const navigate = useNavigate();

    const handleYesClicked = async (category) => {
setProcessOngoing(true)
        const reqdata = await deleteProductCategory(category, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status !== 404 && reqdata.response.status !== 500) {
                console.log(reqdata.response.data.error)
                let errorMsg = reqdata.response?.data.error;

                toast.error(errorMsg, {
                    position: toast.POSITION.TOP_RIGHT,
                    className: 'rotateY animated'
                });
                let response = await getProductCategories(states.userToken.access_token, 1, "");
                // let product_categories_list_response = await getProductCategories(states.userToken.access_token, page, search);


                let response_copy = response.data.data?.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
    
                dispatch({
                    type: "SET",
                    key: "productCategoriesList",
                    payload: response_copy,
                });
            } else {
                //    Should redirect to an Error Page
                // console.log(reqdata.response?.data.error)
                toast.error(reqdata.response?.data?.error, {
                    position: toast.POSITION.TOP_RIGHT,
                    className: 'rotateY animated'
                });
                let response = await getProductCategories(states.userToken.access_token, 1, "");
                // let product_categories_list_response = await getProductCategories(states.userToken.access_token, page, search);


                let response_copy = response.data.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
    
                dispatch({
                    type: "SET",
                    key: "productCategoriesList",
                    payload: response_copy,
                });
            }
        } else {
            let response = await getProductCategories(states.userToken.access_token, 1, "");

            let response_copy = response.data?.data?.map(obj => ({ ...obj, showEdit: false, showDelete: false }))

            dispatch({
                type: "SET",
                key: "productCategoriesList",
                payload: response_copy,
            });
setProcessOngoing(false)
            toast.success("Catégorie de produit supprimée avec succès !", {
                position: toast.POSITION.TOP_RIGHT,
                className: 'rotateY animated'
            });
        }
    }

    return (
        <>
            <div className="table-responsive ">
                <table className="table table-striped dataTable w-100">
                    <thead className="">
                        <tr role={"row"}>
                            {columns && columns.map((item, index) =>
                                <th key={index+"wcdpcc"} className="text-left pl-5" >
                                    {item.label}</th>
                            )}
                            <th className="text-center w-30">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                    {data.length != 0 ? data.map((item, index) =>
                            <tr key={index+"wcdpcd"}>
                                
                                <td className="text-left pl-5">{pageNumber > 1 ? (perPage*(pageNumber-1) + (index + 1)) : (index+1)}</td>
                                <td className="text-left pl-5">
                                    {item.libelle}
                                </td>
                                <td className="">
                                    <BiEdit onClick={() => navigate(`/product-category/${item.id}`)} title="Modifier" style={{ fill: "#2196F3", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-edit-button mr-1" />
                                    <MdDeleteForever onClick={() => handleShowDeleteModal(item.id)} title="Supprimer" style={{ fill: "red", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-delete-button ml-1" />
                                </td>
                                <DeleteConfirmation processOngoing={processOngoing} handleYesClicked={handleYesClicked} title={` la catégorie ${item.libelle} ?`} id={item.id} show={item.showDelete} handleNoClicked={handleCloseDeleteModal} />
                                {/* <DeleteConfirmationInstitutionCategory onExit={onExit} title={"Etes-vous sûr de vouloir supprimer la catégorie " + `${item.libelle}` + " ?"} idCategory={item.id} show={item.showDelete} handleNoClicked={handleCloseDeleteModal} /> */}
                            </tr>
                        ) : <h1 className="ok"></h1>}
                    </tbody>
                </table>
                <Pagination 
                        // pageCount={lastPage} 
                        pageCount={pageCount} 
                        changePage={changePage} />
            </div>

        </>
    )
}

export default CustomDatatableProductCategory
